/** /prep-lists/new: the new-list form, day-by-day or weekly (docs/parity/
 *  prep-lists.md §4.2). `?weekly=1` opens it on Weekly plan. The router
 *  reads search values as JSON, so a typed or linked `?weekly=1` arrives as
 *  the number 1; the string and `true` are taken too. */
import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon, useFeatureGate } from '@/components/ComingSoon';
import { NewListForm } from '@/features/prep-lists/NewListForm';

type Search = { weekly?: 1 };

export const Route = createFileRoute('/_app/prep-lists/new')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    weekly: s.weekly === 1 || s.weekly === '1' || s.weekly === true ? 1 : undefined,
  }),
  component: NewPrepListRoute,
});

function NewPrepListRoute() {
  // Both hooks before any early return (rules of hooks).
  const { weekly } = Route.useSearch();
  const gated = useFeatureGate('prep');
  if (gated) return <ComingSoon feature="prep" />;
  // Keyed by the kind, so following a "New weekly plan" link from the plain
  // form (or back) opens the right form instead of keeping the old one.
  return <NewListForm key={weekly === 1 ? 'weekly' : 'day'} initialWeekly={weekly === 1} />;
}
